
import Section from '../components/Section'
import ProjectCard from '../components/ProjectCard'

export default function Projects() {
  return (
    <Section title="Unsere Projekte" subtitle="Eine kleine Auswahl.">
      <div className="grid gap-6 md:grid-cols-3">
        <ProjectCard
          title="COM - Hub / Offline"
          description={<>
          Videocontent Plattform mit privat Spaces. 
          <br />
          Nur selbst testbar und auf Github sichtbar, da erstes weiterbildungsprojekt und offline genommen wurde.</>}
          image="/ComHubLogo.png"
          href='https://github.com/M2Websolutions-GBR/com-hub.git'
          tags={['React', 'Vite', 'Bootstrap', 'Multer', 'AWS', 'Docker','Terraform', 'CI/CD', 'SonarQube', 'EKS/k8s']}
        />
        <ProjectCard
          title="NFT-Hub (MVP)"
          description="NFT-Marktplatz mit Stripe-Integration und Zertifikat-PDFs."
          href="/nft-hub"
          image="/Landingfull2.png"
          tags={['React', 'Vite', 'Node', 'Stripe', 'cloudinary', 'MongoDB', 'Pupeteer']}
        />

        <ProjectCard
          title="(in Planung)"
          description="Microservice Blueprints"
          image="/src/assets/.jpg"
          tags={['MERN', 'Microservices']}
        />

      </div>
    </Section>
  )
}
